import { render, staticRenderFns } from "./GoogleMapItems.vue?vue&type=template&id=d54243d4"
import script from "./GoogleMapItems.vue?vue&type=script&lang=js"
export * from "./GoogleMapItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports